module.exports = __webpack_public_path__ + "static/media/sellerPageImage.684da399.webp";